import { siteInfo } from '@/mocks/home-data';

export default function HeroSection() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20editorial%20collage%20composition%20with%20overlapping%20magazine%20fragments%2C%20breaking%20news%20texture%20elements%2C%20soft%20crimson%20and%20amber%20gradient%20background%2C%20artistic%20collage%20aesthetic%2C%20entertainment%20media%20atmosphere%2C%20sophisticated%20chaotic%20layout%2C%20newspaper%20clipping%20textures%2C%20warm%20dramatic%20lighting&width=1800&height=900&seq=hero-bagua-bg-2026&orientation=landscape"
          alt="爆料吃瓜主视觉背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-0">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 md:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs font-medium tracking-wider bg-primary-500/90 text-background-50 mb-5">
              {siteInfo.tag}
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-background-50 leading-tight mb-4">
              爆料吃瓜
              <br className="md:hidden" />
              <span className="text-accent-400"> — 全网最热娱乐八卦实时追踪平台</span>
            </h1>

            <p className="text-lg md:text-xl text-background-50/90 font-light mb-2">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mt-4 mb-6">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-background-50/60 mt-1">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => handleScrollTo(e, '#updates')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-flashlight-line"></i>
                查看最新爆料
              </a>
              <a
                href="#topics"
                onClick={(e) => handleScrollTo(e, '#topics')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/15 hover:bg-background-50/25 text-background-50 border border-background-50/30 font-medium rounded-md text-sm transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-hashtag"></i>
                浏览热门话题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/5] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20artistic%20composition%20of%20entertainment%20news%20and%20celebrity%20culture%2C%20warm%20crimson%20and%20gold%20tones%2C%20magazine%20cover%20aesthetic%20with%20abstract%20celebrity%20silhouettes%2C%20breaking%20news%20vibe%2C%20editorial%20design%20elements%2C%20glamorous%20yet%20mysterious%20atmosphere%2C%20paparazzi%20flash%20effect%2C%20dramatic%20lighting%2C%20rich%20textures%2C%20sophisticated%20collage%20style&width=800&height=1000&seq=hero-visual-bagua-main&orientation=portrait"
                alt="爆料吃瓜 - 娱乐八卦主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent rounded-lg"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}